import { lang } from '../localization'
import { Currency, CurrencyList } from '../types/currency'

export function getCurrencyLabel(input: Currency) {
  const currencyItem = CurrencyList.find((item) => item.Value === input)
  if (currencyItem) {
    return lang === 'fa' ? currencyItem.Label.FA : currencyItem.Label.EN
  }
  return input
}
